import { render, staticRenderFns } from "./banks-edit.vue?vue&type=template&id=0b4d39e4&"
import script from "./banks-edit.vue?vue&type=script&lang=js&"
export * from "./banks-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports